// @flow
import React from "react"
import type { OpeningHours } from "data/affiliate/types"
import { Text } from "componentsStyled/Typography"
import { squashSameOpeningHours } from "./helpers"
import { OpeningHoursTableWrap, Pair, Key, Val } from "../styled"

type Props = {|
  data: OpeningHours,
|}

const Regular = ({ data }: Props) => {
  if (!data) return <Text>Not available</Text>

  return (
    <OpeningHoursTableWrap>
      {squashSameOpeningHours(data).map(x => (
        <Pair key={x.name}>
          <Key nomargin>{x.name}</Key>
          <Val nomargin black>
            {x.v}
          </Val>
        </Pair>
      ))}
    </OpeningHoursTableWrap>
  )
}

export default Regular



// WEBPACK FOOTER //
// ./src/pages/Affiliate/Content/Info/OpeningHoursTable/Regular/index.js